//@ts-nocheck
import { application } from '../constants'
import { readExpCookie } from './read-exp-cookie'
import { config } from '../config'

/**
 * Load Google Analytics.
 */
export function loadGoogleAnalytics(pathname) {
  // check if GA script has been loaded
  const script = config.ga.script
  const existingScripts = document.querySelectorAll('script')
  let isGALoaded = false
  for (let i = 0; i < existingScripts.length; i++) {
    if (existingScripts[i].getAttribute('src') === script) {
      isGALoaded = true
      break
    }
  }

  if (!isGALoaded) {
    /* eslint-disable */
    let expCookie = readExpCookie()
    let gaCode = config.ga.id[application.env][expCookie ? 'exp' : 'stock']

    // Add GA script to page.
    ;(function (i, s, o, g, r, a, m) {
      i['GoogleAnalyticsObject'] = r
      ;(i[r] =
        i[r] ||
        function () {
          ;(i[r].q = i[r].q || []).push(arguments)
        }),
        (i[r].l = 1 * new Date())
      ;(a = s.createElement(o)), (m = s.getElementsByTagName(o)[0])
      a.async = 1
      a.src = g
      m.parentNode.insertBefore(a, m)
    })(window, document, 'script', config.ga.script, 'ga')

    // Set up GA.
    window.ga('create', gaCode, 'auto')
    if (expCookie) {
      window.ga('set', 'userId', expCookie.expId + '|' + expCookie.userId)
    }
  }
  if (pathname && typeof pathname == 'string') {
    const fullPath = '/dashboard' + pathname
    window.ga('send', 'pageview', fullPath)
  } else {
    window.ga('send', 'pageview')
  }
}
